import { css } from '@emotion/css'
import type { SelectProps } from '@mantine/core'
import { Select } from '@mantine/core'
import { colors } from 'settings/colors'
import { useSelectClickToggle } from 'utils/useSelectClickToggle'

export const SelectDropdown = (props: SelectProps) => {
  const selectClickToggle = useSelectClickToggle()

  return (
    <Select
      // spread first so a caller controlling the dropdown still wins
      {...(props.searchable ? selectClickToggle : {})}
      {...props}
      classNames={{
        // the doubled class outranks Mantine's highlight and the app-wide [data-checked] blue
        option: css({
          '&&[data-checked], &&[data-checked][data-combobox-selected], &&[data-checked]:hover': {
            backgroundColor: colors.primary,
            color: colors.white,
          },
        }),
        ...(typeof props.classNames === 'object' ? props.classNames : {}),
      }}
    />
  )
}
